import { RecommendedSkill } from '@map/types';
import { Reducer } from 'redux';
import { createSelector } from 'reselect';
import { experiencePropSelector } from './experiences';

export const RECOMMENDED_SKILLS_FETCHED = 'RECOMMENDED_SKILLS_FETCHED';
export const EXPERIENCE_RECOMMENDED_SKILLS_UPDATED = 'EXPERIENCE_RECOMMENDED_SKILLS_UPDATED';

type State = RecommendedSkill[];

export const actionCreators = {
  allFetched: (data: RecommendedSkill[]) => ({ type: RECOMMENDED_SKILLS_FETCHED, data }) as const,
  forExperienceFetched: (experienceId: number, recommendedSkills: RecommendedSkill[]) =>
    ({
      type: EXPERIENCE_RECOMMENDED_SKILLS_UPDATED,
      data: { experienceId, recommendedSkills },
    }) as const,
};

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;

const recommendedSkills: Reducer<State, Action> = (state = [], action) => {
  switch (action.type) {
    case EXPERIENCE_RECOMMENDED_SKILLS_UPDATED:
      return state
        .filter((rec) => rec.experience_id !== action.data.experienceId)
        .concat(action.data.recommendedSkills);
    case RECOMMENDED_SKILLS_FETCHED:
      return action.data;
    default:
      return state;
  }
};

export default recommendedSkills;

type RootState = {
  recommendedSkills: State;
};

// SELECTORS
const recommendedSkillsSelector = (state: RootState) => state.recommendedSkills;

export const recommendedSkillsForExperienceSelector = createSelector(
  experiencePropSelector,
  recommendedSkillsSelector,
  (exp, recommendations) => recommendations.filter((skill) => skill.experience_id === exp.id),
);
